import { DEBUG } from '@src/DEBUG';
DEBUG.open ( '/commons/plugins/blink.controller.ts' );

import { FdmPlugin, FdmPluginInterface } from './plugins';

export class BlinkController extends FdmPlugin implements FdmPluginInterface {

    // required name identifier
    static meta = {
        label: 'PLUGINS.BLINKR.LABEL',
        name: 'blink-controller',
        tooltip: 'PLUGINS.BLINKR.TOOLTIP',
        translator: 'PLUGINS.BLINKR',
        icon: 'heartbeat',
        shortcut: false,
    
        category: FdmPlugin.category.generic,
        
        cardinality: FdmPlugin.cardinality.one,
        types: [ FdmPlugin.types.transformController ],
        features: [ FdmPlugin.features.pulse ],
        ds_types: [ FdmPlugin.ds_types.all ]
    };

    objectInjected() {
        this.startPulse();
    }

    pulse() {
        if ( this.object ) {
            this.object.show = false;
        }
    }

    pulseOff() {
        if ( this.object ) {
            this.object.show = true;
        }
    }
}


